import * as urlUtils from 'utils/Url';


export function getPathControlEmailTemplates(qs={}) {
  return urlUtils.appendQueryString(`/control/email-templates`, qs);
}

export function getPathControlAddEmailTemplate() {
  return `/control/email-templates/add`;
}

export function getPathControlEditEmailTemplate(templateId) {
  return `/control/email-templates/${templateId}/edit`;
}

export function getPathControlReplicateEmailTemplate(templateId) {
  return `/control/email-templates/${templateId}/replicate`;
}
